import { mapGetters } from 'vuex'

// home
export const constantsComputed = {
  ...mapGetters('constants', ['baseURL', 'configMap', 'isMobile'])
}
